var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M11,4V0l7,7-7,7V9.9C6,9.9,2.5,11.5,0,15,1,10,4,5,11,4Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }